// «Calendario» del participante — agenda de cuestionarios abiertos y próximos.
export const calendar = {
  calendar_tab_label: "Calendario",
  calendar_due_before: "Para hacer antes del {{date}}",
  calendar_opens_on: "Se abre el {{date}}",
  calendar_next_time: "Próxima vez: {{date}}",
  calendar_empty: "Nada previsto por el momento",
};
